import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SivaService } from 'src/api/v2';
import { ONE_WAY_IN_OPPORTUNITY_SIVA_CONTRACT_CONNECTION } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';
import useOneWayIn from '../../hooks/use-one-way-in';

const useOpportunitySivaContract = (formId: string | undefined) => {
  const { oneWayInOpportunityById } = useOneWayIn(formId);
  const { checkAccess } = useAuth();
  const [service] = useState(() => new SivaService());

  const isSivaOperator = checkAccess('UI_SivaBusinessGarden').read || checkAccess('UI_SivaIncubator').read;
  const opportunity = oneWayInOpportunityById.data;
  const organizationNumber =
    opportunity?.organizationNumber?.startsWith('8') || opportunity?.organizationNumber?.startsWith('9')
      ? opportunity?.organizationNumber
      : undefined;

  const { data, isFetched } = useQuery({
    queryKey: [ONE_WAY_IN_OPPORTUNITY_SIVA_CONTRACT_CONNECTION, opportunity?.id],
    queryFn: () =>
      service.findSivaContractDetails(opportunity?.clusterMemberId, organizationNumber, opportunity?.id),
    enabled: isSivaOperator && opportunity?.id !== undefined,
    retry: false,
    retryOnMount: false,
  });

  return { data, hasSivaContract: !!data, isFetched };
};

export default useOpportunitySivaContract;
